import { gerarUUID } from "../../../util/uuid.utils";

/**
 * Modelo de objeto para Campo Personalizado do formulário;
 * @class CampoPersonalizado
 * @namespace CampoPersonalizado
 */
export default class CampoPersonalizado {
  constructor(id = null, titulo = '', tituloHtml = '', obrigatorio = false, tipoInput = '', opcoes = [], ordem = null, blocoPadrao = null, isCampoSocio = false, uuid = gerarUUID(), respostaTexto = '', respostaOpcoes = [], hasOpcaoOutro = false, respostasSocios = []) {
    this.id = id;
    this.titulo = titulo;
    this.tituloHtml = tituloHtml;
    this.obrigatorio = obrigatorio;
    this.tipoInput = tipoInput;
    this.opcoes = opcoes;
    this.ordem = ordem;
    this.blocoPadrao = blocoPadrao;
    this.isCampoSocio = isCampoSocio;
    this.uuid = uuid;
    this.respostaTexto = respostaTexto;
    this.respostaOpcoes = respostaOpcoes;
    this.respostasSocios = respostasSocios;
    this.hasOpcaoOutro = hasOpcaoOutro;
  }

  /**
   * Atualiza modelo com dados válidos de um objeto com dados de
   * formulário;
   * @param {Object} formData Objeto com dados do formulário
   */
  updateDados(formData) {
    for (let propriedade in formData) {
      if (!Object.keys(formData).includes(propriedade)) {
        console.warn(`WARN: Propriedade "${propriedade}" não é valido para modelo`);
        continue;
      }
      this[propriedade] = formData[propriedade];
    }
  }

  asRequestBody() {
    const body = this; // Mock
    return body;
  }

  cleanBody(body) {
    for (const prop in body) {
      if (body[prop] === '' || body[prop] === null || (Array.isArray(body[prop]) && body[prop].length == 0)) {
        delete body[prop];
      }
    }
  }

  asModel(response) {
    return response
  }
}
